import { defineMessages } from 'react-intl'

export const homeAccessMessages = defineMessages({
  systemAccess: {
    id: 'homeAccess.systemAccess',
    description: 'Heading of "System Access" block',
    defaultMessage: 'System Access',
  },
  systemAccessExpires: {
    id: 'homeAccess.systemAccessExpires',
    description: 'Text going before system access expiration date',
    defaultMessage: 'Expires',
  },
  systemAccessNeverExpire: {
    id: 'homeAccess.systemAccessNeverExpire',
    description: '',
    defaultMessage: 'Access Granted',
  },
})

export const lightStatusesMessages = defineMessages({
  statusesListControllerTitle: {
    id: 'lightStatuses.statusesListControllerTitle',
    description: '',
    defaultMessage: 'Controller',
  },
  statusesListReportsTitle: {
    id: 'lightStatuses.statusesListReportsTitle',
    description: '',
    defaultMessage: 'Diagnostic Reports',
  },
  statusesListConnectionTitle: {
    id: 'lightStatuses.statusesListConnectionTitle',
    description: '',
    defaultMessage: 'Control Connection',
  },
})
